// pencereKapat.js — PENCERE KAPATMA: TEK TİP, TEK KAYNAK (12 Eki 2026)
//
// 🔑 Serkan: *"web panelde bir hücre açıkken (örneğin EDIT ekranı vs.) en altta CANCEL ile pencere kapanıyor;
//    ESC tuşu ile veya sağ üstte X ile de kapansın."* · kaydedilmemiş değişiklik varken: **A** — SORMADAN kapanır
//    (alttaki CANCEL ne yapıyorsa o; "DISCARD CHANGES?" sorusu YOK).
//
// 🔴 ÖNCESİ (12 Eki ölçümü): 40 pencere, ortak parça yok; ESC yalnız 2 yerde (Drawer, Bildirim) ve ikisi de
//    `window` dinleyicisiydi — iç içe pencerede tek ESC ALTTAKİLERİ DE kapatıyordu (hata kartı + arkasındaki çekmece).
//    Sağ üst kapatma 27 pencerede, üç ayrı biçimde (x · × · ✕), büyük FTL düzenleme pencerelerinde hiç yoktu.
//
// KURAL: ESC yalnız EN ÜSTTEKİ pencereyi kapatır. Pencereler açıldıkları sırayla bir yığına girer; iç içe açılan
//    (EDIT DUTY içinde ⓘ, gerekçe penceresi, meydan beyanı) sonradan açıldığı için üsttedir.
//    `kapat` null ise (pencere o an kapatılamaz — ör. kaydediliyor) ESC HİÇBİR ŞEY yapmaz ve ALTTAKİNE DE GEÇMEZ.
import React, { useEffect, useRef } from 'react';

const yigin = [];   // { ref, sira } — en büyük `sira` = en üstteki
let sayac = 0;

// 🔴 SIRA EFEKTTEN ALINMAZ (12 Eki 2026, testte yakalandı): React efektleri ÖNCE ÇOCUKTA çalıştırır — aynı anda açılan
//    iç içe iki pencerede dıştaki yığına SONRA girer ve "en üstteki" sanılırdı (ESC içteki yerine dıştakini kapatıyordu).
//    Sıra ÇİZİM anında verilir: çizim ebeveynden çocuğa iner, açılış anı da çizimdir.
function escDinle(e) {
  if (e.key !== 'Escape' || !yigin.length) return;
  const ust = yigin.reduce((a, b) => (b.sira > a.sira ? b : a));
  e.preventDefault();
  e.stopPropagation();
  const f = ust.ref.current;
  if (typeof f === 'function') f();
}

let dinleniyor = false;
function dinleyiciyiKur() {
  if (dinleniyor || typeof window === 'undefined') return;
  window.addEventListener('keydown', escDinle);
  dinleniyor = true;
}

/** Pencere açıkken ESC ile kapatma. `acik` false iken yığına girmez. */
export function usePencereKapat(kapat, acik = true) {
  const ref = useRef(kapat);
  ref.current = kapat;
  const durum = useRef({ acik: false, sira: 0 });
  if (acik && !durum.current.acik) durum.current.sira = ++sayac;   // açıldığı çizimde sıra alır
  durum.current.acik = acik;
  useEffect(() => {
    if (!acik) return undefined;
    dinleyiciyiKur();
    const kayit = { ref, sira: durum.current.sira };
    yigin.push(kayit);
    return () => {
      const i = yigin.indexOf(kayit);
      if (i >= 0) yigin.splice(i, 1);
    };
  }, [acik]);
}

/** Testler için: yığındaki pencere sayısı. */
export function _acikPencereSayisi() { return yigin.length; }

/** Sağ üst ✕ — bütün pencerelerde aynı kutu. Erişilebilir adı "Close window": testlerdeki
 *  `getByText('CLOSE')` / `getByRole('button', { name: 'CLOSE' })` ile ÇAKIŞMAZ. */
export function KapatX({ onClose, testid = 'pencere-kapat-x', disabled = false, style }) {
  return (
    <button type="button" data-testid={testid} aria-label="Close window" title="Close (Esc)"
            disabled={disabled} onClick={e => { e.stopPropagation(); if (!disabled) onClose(); }}
            style={{ width:32, height:32, flexShrink:0, background:'transparent', border:'1px solid var(--border)',
                     borderRadius:6, color:'var(--t2)', fontSize:16, lineHeight:1, cursor: disabled ? 'default' : 'pointer',
                     opacity: disabled ? .4 : 1, display:'flex', alignItems:'center', justifyContent:'center',
                     padding:0, ...style }}>
      ✕
    </button>
  );
}
